const portfolioLightbox = document.querySelector('#portfolio-lightbox');

if (portfolioLightbox) {
  const triggers = [...document.querySelectorAll('.portfolio-image')];
  const track = portfolioLightbox.querySelector('.portfolio-lightbox-track');
  const viewport = portfolioLightbox.querySelector('.portfolio-lightbox-viewport');
  const closeButton = portfolioLightbox.querySelector('.portfolio-lightbox-close');
  const previousButton = portfolioLightbox.querySelector('.portfolio-lightbox-arrow.is-previous');
  const nextButton = portfolioLightbox.querySelector('.portfolio-lightbox-arrow.is-next');
  const count = portfolioLightbox.querySelector('.portfolio-lightbox-count');
  const items = triggers.map((trigger) => ({
    src: trigger.dataset.portfolioSrc,
    alt: trigger.dataset.portfolioAlt || ''
  }));
  let activeIndex = 0;
  let pageScrollY = 0;
  let returnFocus;
  let gestureStart = null;

  track.innerHTML = items.map((item, index) => `
    <figure class="portfolio-lightbox-slide" data-portfolio-slide="${index}">
      <img src="${item.src}" alt="${item.alt}" draggable="false">
    </figure>
  `).join('');

  const render = (animate = true) => {
    track.classList.toggle('without-transition', !animate);
    track.style.transform = `translate3d(${-activeIndex * 100}%, 0, 0)`;
    count.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(items.length).padStart(2, '0')}`;
    if (!animate) requestAnimationFrame(() => track.classList.remove('without-transition'));
  };

  const move = (direction) => {
    activeIndex = (activeIndex + direction + items.length) % items.length;
    render();
  };

  const open = (index, trigger) => {
    activeIndex = index;
    returnFocus = trigger;
    pageScrollY = window.scrollY;
    portfolioLightbox.hidden = false;
    portfolioLightbox.setAttribute('aria-hidden', 'false');
    document.body.style.top = `-${pageScrollY}px`;
    document.body.classList.add('is-lightbox-open');
    render(false);
    closeButton.focus();
  };

  const close = () => {
    portfolioLightbox.hidden = true;
    portfolioLightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-lightbox-open');
    document.body.style.top = '';
    window.scrollTo(0, pageScrollY);
    if (returnFocus) returnFocus.focus();
  };

  triggers.forEach((trigger, index) => trigger.addEventListener('click', () => open(index, trigger)));
  previousButton.addEventListener('click', () => move(-1));
  nextButton.addEventListener('click', () => move(1));
  closeButton.addEventListener('click', close);

  viewport.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'touch') return;
    gestureStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
    viewport.setPointerCapture(event.pointerId);
  });

  viewport.addEventListener('pointerup', (event) => {
    if (!gestureStart || gestureStart.id !== event.pointerId) return;
    const deltaX = event.clientX - gestureStart.x;
    const deltaY = event.clientY - gestureStart.y;
    if (Math.abs(deltaX) >= 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) move(deltaX < 0 ? 1 : -1);
    gestureStart = null;
  });

  viewport.addEventListener('pointercancel', () => { gestureStart = null; });
  portfolioLightbox.addEventListener('click', (event) => {
    if (event.target === portfolioLightbox) close();
  });

  document.addEventListener('keydown', (event) => {
    if (portfolioLightbox.hidden) return;
    if (event.key === 'Escape') close();
    if (event.key === 'ArrowLeft') move(-1);
    if (event.key === 'ArrowRight') move(1);
    if (event.key === 'Tab') {
      const focusable = [...portfolioLightbox.querySelectorAll('button:not([disabled])')];
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  render(false);
}
